import { Component, Vue } from "vue-facing-decorator";

@Component({
    name: "TermsViewComponent",
    // components: {
    //     VsInput,
    //     VsResult,
    //     FacetCategory,
    //     ActiveFacetCategory,
    // },
})
export default class TermsViewComponent extends Vue {}
